
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 6.23221H12C11.45 6.23221 11 6.64524 11 7.15006C11 7.65488 11.45 8.06791 12 8.06791H14V18.1643H2V8.06791H4C4.55 8.06791 5 7.65488 5 7.15006C5 6.64524 4.55 6.23221 4 6.23221H2C0.9 6.23221 0 7.05828 0 8.06791V18.1643C0 19.1739 0.9 20 2 20H14C15.1 20 16 19.1739 16 18.1643V8.06791C16 7.05828 15.1 6.23221 14 6.23221Z","fill":"white"}}),_c('path',{attrs:{"d":"M8.0002 13.575C8.5502 13.575 9.0002 13.162 9.0002 12.6572V3.47866H10.7902C11.2402 3.47866 11.4602 2.98302 11.1402 2.69848L8.3502 0.137678C8.1502 -0.0458926 7.8402 -0.0458926 7.6402 0.137678L4.85019 2.69848C4.54018 2.98302 4.76018 3.47866 5.21019 3.47866H7.00019V12.6572C7.00019 13.162 7.4502 13.575 8.0002 13.575Z","fill":"white"}})])
          )
        }
      }
    